export enum KeyboardShortcutType {
    SIMPLE_CLICK = 'SIMPLE_CLICK',
    FOCUS = 'FOCUS'
}
